module.exports = __webpack_public_path__ + "img/homepage-4.0027e897.webp";